module.exports = __webpack_public_path__ + "media/images/scoreBet__scoredSoon-7772a54e2cea203e7183af3a784c6d5e.png";